import { createSelector } from 'reselect';
import { FAI_STATUS } from 'lib/constants';
import { getFAICurrentInspection } from './getFAICurrentInspection';

const getFAIHasActiveInspection = createSelector(
  [getFAICurrentInspection],
  (currentInspection) => {
    const status = currentInspection?.status;
    return status === FAI_STATUS.PENDING || status === FAI_STATUS.IN_PROGRESS;
  }
);

export { getFAIHasActiveInspection };
